import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Button } from "catalyst/button";
import { ErrorMessage, Field } from "catalyst/fieldset";
import { Input } from "catalyst/input";
export const EmailAuthForm = ({ email, emailLabel, challenge, submitting, error, buttonLabel, buttonPlain = false, subgrid = false, autoFocus = true, onEmailChange, onClearError, onSubmit, }) => {
    const [code, setCode] = useState("");
    const input = useRef(null);
    const wasSubmitting = useRef(submitting);
    const showCode = challenge !== null;
    const waitingForCode = showCode && code.length !== 6;
    useEffect(() => {
        setCode("");
    }, [challenge]);
    useEffect(() => {
        if (!submitting && (autoFocus || challenge || wasSubmitting.current))
            input.current?.focus();
        wasSubmitting.current = submitting;
    }, [autoFocus, challenge, submitting]);
    return (_jsx("form", { className: subgrid
            ? "col-span-full grid min-w-0 grid-cols-subgrid"
            : "w-full max-w-72", onSubmit: (event) => {
            event.preventDefault();
            if (submitting || waitingForCode)
                return;
            onSubmit(showCode ? code : email);
        }, children: _jsxs(Field, { className: subgrid ? "col-span-full grid min-w-0 grid-cols-subgrid" : "", children: [_jsxs("div", { "data-slot": "control", className: subgrid
                        ? "col-span-full grid min-w-0 grid-cols-subgrid items-center"
                        : "flex items-center gap-2", children: [_jsx(Input, { ref: input, "aria-label": showCode ? "Код из письма" : emailLabel, autoCapitalize: "none", autoComplete: showCode ? "one-time-code" : "email", className: subgrid ? "min-w-0 max-w-72" : "min-w-0 flex-1", disabled: submitting, inputMode: showCode ? "numeric" : "email", invalid: Boolean(error), maxLength: showCode ? 6 : 254, name: showCode ? "code" : "email", pattern: showCode ? "[0-9]{6}" : undefined, placeholder: showCode ? "Код из письма" : "Email", required: true, spellCheck: false, type: showCode ? "text" : "email", value: showCode ? code : email, onChange: (event) => {
                                if (showCode)
                                    setCode(event.target.value.replace(/[^0-9]/g, "").slice(0, 6));
                                else
                                    onEmailChange(event.target.value);
                                onClearError();
                            }, onPaste: (event) => {
                                if (!showCode)
                                    return;
                                event.preventDefault();
                                setCode(event.clipboardData
                                    .getData("text")
                                    .replace(/[^0-9]/g, "")
                                    .slice(0, 6));
                                onClearError();
                            } }), _jsx(Button, { "aria-busy": submitting, className: subgrid
                                ? "col-start-1 mt-2 self-start justify-self-start whitespace-nowrap sm:col-start-2 sm:row-start-1 sm:mt-0"
                                : "shrink-0", ...(buttonPlain
                                ? { plain: true }
                                : { color: waitingForCode ? "zinc" : "light" }), disabled: submitting || waitingForCode, type: "submit", children: buttonLabel })] }), error && (_jsx(ErrorMessage, { className: subgrid ? "col-span-full" : "", role: "alert", children: error }))] }) }));
};
